import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Button, DatePicker, Dropdown, Form, Input } from 'antd'
import moment from 'moment'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { inject, observer } from 'mobx-react'
import { Tuning2OutlineIcon } from '../../../components/AppIcon'
import { checkValidFormFieldValue } from '../../../utils/helper'
import { DATE_FORMAT_SLASH, ISO_DATE_FORMAT } from '../../../constants'

const { RangePicker } = DatePicker

const AdvanceFilterBlockBoardReport = ({ boardReportStore }) => {
  const [showFilter, setShowFilter] = useState(false)
  const location = useLocation()
  const history = useHistory()

  const queryStringParse = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  )

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        userCreated: queryStringParse?.userCreated || undefined,
        dateRange:
          queryStringParse?.createdAtFrom && queryStringParse?.createdAtTo
            ? [
                moment(queryStringParse.createdAtFrom, ISO_DATE_FORMAT),
                moment(queryStringParse.createdAtTo, ISO_DATE_FORMAT),
              ]
            : undefined,
      })
    }
  }, [queryStringParse, setFieldsValue, showFilter])

  const onFinish = values => {
    const from = values?.dateRange?.[0]?.format(ISO_DATE_FORMAT)
    const to = values?.dateRange?.[1]?.format(ISO_DATE_FORMAT)

    const newQueryParams = {
      ...queryStringParse,
      userCreated: values?.userCreated?.trim() || undefined,
      createdAtFrom: from || undefined,
      createdAtTo: to || undefined,
      page: 0,
    }

    boardReportStore.setQueryParams(newQueryParams)

    const newQueryString = queryString.stringify(newQueryParams, {
      skipNull: true,
      skipEmptyString: true,
    })

    history.replace(`/board-report?${newQueryString}`)
    onToggleFilter()
  }

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(queryStringParse?.userCreated)) count++
    if (queryStringParse?.createdAtFrom || queryStringParse?.createdAtTo) count++

    return count
  }, [queryStringParse])

  const handleClearFilter = () => {
    const newQueryParams = {
      title: queryStringParse?.title || undefined,
      page: 0,
      size: queryStringParse?.size || 10,
    }

    boardReportStore.setQueryParams(newQueryParams)

    const newQueryString = queryString.stringify(newQueryParams, {
      skipNull: true,
      skipEmptyString: true,
    })

    history.replace(`/board-report?${newQueryString}`)
  }

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item
                label="Người tạo"
                name="userCreated"
                style={{ marginBottom: 16 }}>
                <Input
                  placeholder="Lọc theo người tạo"
                  allowClear
                  className="h-40"
                />
              </Form.Item>
              <Form.Item
                label="Ngày tạo"
                name="dateRange"
                style={{ marginBottom: 16 }}>
                <RangePicker
                  style={{ width: '100%' }}
                  allowClear
                  placeholder={['Từ ngày', 'Đến ngày']}
                  format={DATE_FORMAT_SLASH}
                  className="h-40"
                />
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>
              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  handleClearFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject('boardReportStore')(observer(AdvanceFilterBlockBoardReport))
